<template>
  <div v-show="!this.isShow.isLDShow && !this.isShow.isPOShow" id="music" class="music" @click="toggleMusic">
    <div class="cloud">
      <div class="note on" :class="isPlay ? 'rotating' : 'off'"></div>
    </div>
    <audio :src="musicURL" id="myMusic" preload="preload" loop></audio>
  </div>
</template>

<script>
export default {
  name: 'MusicPlayer',
  props: {
    isShow: {
      type: Object
    },
    mFlag: {
      type: Boolean
    }
  },
  data () {
    return {
      musicURL: 'https://www.jiandoukeji.com/h5/2018/guoke2018/music/bgm.mp3',
      isPlay: true
    }
  },
  mounted () {
    this.audioPlay()
  },
  methods: {
    toggleMusic () {
      if (this.isPlay) {
        this.audioPause()
      } else {
        this.audioPlay()
      }
      this.isPlay = !this.isPlay
    },
    audioPlay () {
      let audio = document.getElementById('myMusic')
      audio.play()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.play()
      }, false)
    },
    audioPause () {
      let audio = document.getElementById('myMusic')
      audio.pause()
      document.addEventListener('WeixinJSBridgeReady', function () {
        audio.pause()
      }, false)
    }
  },
  watch: {
    mFlag () {
      console.log('triggered');
      setTimeout(() => {
        this.audioPlay();
      }, 400);
    }
  }
}
</script>

<style lang="less" scoped>
.music {
  position: absolute;
  right: .5rem;
  top: .5rem;
  z-index: 3;
  margin-left: 1rem;
  margin-bottom: 1rem;
  width: 2.75rem /* 44/16 */;
  height: 2.25rem /* 36/16 */;
  .cloud {
    .note {
      width: 2.1875rem /* 35/16 */;
      height: 2.1875rem /* 35/16 */;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .on {
      background-image: url('./music-on.png');
    }
    .off {
      background-image: url('./music-off.png');
    }
    .rotating {
      animation: rotate-music 2s linear infinite;
    }
  }
  @keyframes rotate-music {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
